import fetcher, { MethodEnum } from 'utils/helpers/browser/newFetcher';
import { getDiscipline } from 'utils/helpers/browser/discipline';
import { ApiResponseInterface } from 'utils/helpers/browser/getResponse';

export class PaymentService {
    // creates payment request for membership application
    async createApplication(
        applicationId: string
    ): Promise<ApiResponseInterface> {
        return await fetcher<ApiResponseInterface>(
            '/api/payment/create',
            MethodEnum.POST,
            null,
            {
                data: {
                    product: 'membership',
                    product_data: {
                        applicationId: applicationId,
                        discipline: getDiscipline(),
                    },
                },
            }
        );
    }

    // creates payment request for person
    async createPerson(personId: string): Promise<ApiResponseInterface> {
        return await fetcher<ApiResponseInterface>(
            '/api/payment/create',
            MethodEnum.POST,
            null,
            {
                data: {
                    product: 'membership',
                    product_data: {
                        personId: personId,
                        discipline: getDiscipline(),
                    },
                },
            }
        );
    }

    // creates payment request for bulk payment
    async createBulk(bulkMembershipId: number): Promise<ApiResponseInterface> {
        return await fetcher<ApiResponseInterface>(
            '/api/payment/create',
            MethodEnum.POST,
            null,
            {
                data: {
                    product: 'bulk_membership',
                    product_data: {
                        membership_bulk_payment_id: bulkMembershipId,
                    },
                },
            }
        );
    }
}
